/* =========================================================
   NA LEIBERL – Einkaufswagerl (Cart Drawer + Warenkorb-Seite /cart)
   - Rabattcode: Code eingeben -> wird per /cart/update.js auf den Warenkorb gelegt
   - eingelöste Codes als Chips mit "×" zum Entfernen
   - ungültige Codes: Hinweis anzeigen und Code wieder entfernen
   - Vorschläge "Darf's a bisserl mehr sein?": Pfeile zum Durchblättern
   Seitenansicht: wird danach neu gezeichnet (Section "cart-drawer").
   Warenkorb-Seite: wird nach erfolgreicher Änderung neu geladen.
   ========================================================= */
(function () {
  'use strict';
  if (window.__nlWagerl) return; // Datei kann auf /cart doppelt eingebunden sein
  window.__nlWagerl = true;

  var TEXTE = {
    leer: 'Bitte gib einen Rabattcode ein.',
    ungueltig: function (c) { return 'Der Code „' + c + '“ ist leider nicht gültig oder nicht mit deinem Einkauf kombinierbar.'; },
    fehler: 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    laedt: '…'
  };

  var ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M3 12V4h8l10 10-8 8L3 12z"/><circle cx="7.5" cy="8.5" r="1.4"/>' +
    '</svg>';

  function esc(t) {
    return String(t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function warenkorb() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function imWagerl(el) { return !!(el && el.closest('#CartDrawer')); }

  /* Wagerl + Warenkorb-Icon neu zeichnen */
  function neuZeichnen(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    if (sections['cart-drawer']) {
      var neu = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('.drawer__inner');
      var alt = document.querySelector('#CartDrawer .drawer__inner');
      if (neu && alt) alt.innerHTML = neu.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var html = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bubble && html) bubble.innerHTML = html.innerHTML;
    }
  }

  function codesSetzen(codes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(','), sections: 'cart-drawer,cart-icon-bubble' })
    }).then(function (r) {
      if (!r.ok) throw new Error('update');
      return r.json();
    });
  }

  /* ---------- Rabattcode-Bereiche (Seitenansicht und /cart) ---------- */
  function alleBereiche() { return document.querySelectorAll('.nl-code'); }
  function seitenBereich() { return document.querySelector('.nl-cp .nl-code'); }
  function wagerlBereich() { return document.querySelector('#CartDrawer .nl-code'); }

  function fehlerZeigen(bereich, text) {
    var p = bereich && bereich.querySelector('.nl-code__fehler--js');
    if (!p) return;
    p.textContent = text;
    p.hidden = !text;
  }

  /* Chips mit den eingelösten Codes füllen */
  function chipsFuellen(cart) {
    var codes = (cart.discount_codes || []).filter(function (c) { return c.applicable; });
    Array.prototype.forEach.call(alleBereiche(), function (bereich) {
      var liste = bereich.querySelector('.nl-code__liste');
      if (!liste) return;
      liste.innerHTML = codes.map(function (c) {
        return '<li class="nl-code__chip">' + ICON + '<span>' + esc(c.code) + '</span>' +
          '<button type="button" class="nl-code__weg" data-nl-code-weg="' + esc(c.code) + '" aria-label="Code ' + esc(c.code) + ' entfernen">×</button></li>';
      }).join('');
      liste.hidden = codes.length === 0;
      liste.dataset.nlGefuellt = '1';
    });
  }

  var beschaeftigt = false;

  function anwenden(neuerCode, entfernen, bereich) {
    if (beschaeftigt) return;
    beschaeftigt = true;
    var aufSeite = !imWagerl(bereich);
    var knopf = bereich && bereich.querySelector('.nl-code__knopf');
    var knopfText = knopf ? knopf.textContent : '';
    if (knopf) { knopf.disabled = true; knopf.textContent = TEXTE.laedt; }
    fehlerZeigen(bereich, '');

    function fertig() {
      if (knopf) { knopf.disabled = false; knopf.textContent = knopfText; }
      beschaeftigt = false;
    }

    warenkorb()
      .then(function (cart) {
        var codes = (cart.discount_codes || [])
          .filter(function (c) { return c.applicable; })
          .map(function (c) { return c.code; });
        if (entfernen) {
          codes = codes.filter(function (c) { return c.toLowerCase() !== entfernen.toLowerCase(); });
        }
        if (neuerCode && codes.map(function (c) { return c.toLowerCase(); }).indexOf(neuerCode.toLowerCase()) === -1) {
          codes.push(neuerCode);
        }
        return codesSetzen(codes).then(function (data) {
          var ungueltig = (data.discount_codes || []).filter(function (c) { return !c.applicable; });
          if (ungueltig.length) {
            // ungültigen Code gleich wieder entfernen, damit er nicht hängen bleibt
            var gueltig = (data.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
            return codesSetzen(gueltig).then(function (data2) {
              neuZeichnen(data2.sections);
              chipsFuellen(data2);
              fehlerZeigen(aufSeite ? seitenBereich() : wagerlBereich(), TEXTE.ungueltig(ungueltig[0].code));
              fertig();
            });
          }
          if (aufSeite) {
            // Warenkorb-Seite: Summen kommen vom Server -> neu laden
            window.location.reload();
            return;
          }
          neuZeichnen(data.sections);
          chipsFuellen(data);
          fertig();
        });
      })
      .catch(function () {
        fehlerZeigen(bereich, TEXTE.fehler);
        fertig();
      });
  }

  function codeAusFeld(bereich) {
    var feld = bereich && bereich.querySelector('.nl-code__feld');
    var code = (feld && feld.value || '').trim();
    if (!code) { fehlerZeigen(bereich, TEXTE.leer); return; }
    anwenden(code, null, bereich);
  }

  // Seitenansicht: eigenes Formular
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.nl-code__form');
    if (!form) return;
    e.preventDefault();
    codeAusFeld(form.closest('.nl-code'));
  });

  // Warenkorb-Seite: Knopf (kein eigenes Formular, weil im Warenkorb-Formular)
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest && e.target.closest('[data-nl-code-seite]');
    if (!knopf) return;
    e.preventDefault();
    codeAusFeld(knopf.closest('.nl-code'));
  });

  // Enter im Code-Feld auf /cart darf nicht das Warenkorb-Formular abschicken
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var feld = e.target.closest && e.target.closest('.nl-code--seite .nl-code__feld');
    if (!feld) return;
    e.preventDefault();
    codeAusFeld(feld.closest('.nl-code'));
  });

  document.addEventListener('click', function (e) {
    var weg = e.target.closest && e.target.closest('[data-nl-code-weg]');
    if (!weg) return;
    e.preventDefault();
    anwenden(null, weg.getAttribute('data-nl-code-weg'), weg.closest('.nl-code'));
  });

  /* ---------- Vorschläge: Pfeile zum Durchblättern ---------- */
  function pfeileAktualisieren(liste) {
    var box = liste && liste.closest('.nl-up');
    if (!box) return;
    var zurueck = box.querySelector('[data-nl-up="-1"]');
    var weiter = box.querySelector('[data-nl-up="1"]');
    var max = liste.scrollWidth - liste.clientWidth - 2;
    if (zurueck) zurueck.disabled = liste.scrollLeft <= 2;
    if (weiter) weiter.disabled = liste.scrollLeft >= max;
  }
  function allePfeile() {
    Array.prototype.forEach.call(document.querySelectorAll('.nl-up__liste'), pfeileAktualisieren);
  }

  document.addEventListener('click', function (e) {
    var pfeil = e.target.closest && e.target.closest('[data-nl-up]');
    if (!pfeil) return;
    var liste = pfeil.closest('.nl-up').querySelector('.nl-up__liste');
    var karte = liste.querySelector('.nl-up__karte');
    var schritt = karte ? karte.getBoundingClientRect().width + 10 : liste.clientWidth * 0.8;
    liste.scrollBy({ left: schritt * Number(pfeil.getAttribute('data-nl-up')), behavior: 'smooth' });
  });

  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('nl-up__liste')) pfeileAktualisieren(e.target);
  }, true);

  window.addEventListener('resize', function () { allePfeile(); });

  /* ---------- Flug-Animation: Produktbild fliegt vom Button zum Wagerl-Icon ----------
     Ablauf: Klick auf "Ins Einkaufswagerl" -> Artikel wird hinzugefügt -> das Produktbild (Kreis, roter Rand)
     fliegt im Bogen zum Wagerl-Icon oben, das Icon wackelt, die Zahl hüpft -> danach öffnet die Seitenansicht.
     Technisch: die Methode renderContents des Wagerls (öffnet die Seitenansicht) wird kurz verzögert. */
  var FLUG_MS = 650;
  var letzterKlick = { knopf: null, zeit: 0 };
  var KNOPF_SELEKTOR = '.product-form__submit, .nl-sticky-atc__btn, button[name="add"], .quick-add__submit';

  var FLUG_CSS =
    '.nl-flug{position:fixed;left:0;top:0;z-index:2147483000;width:6.4rem;height:6.4rem;margin:-3.2rem 0 0 -3.2rem;' +
      'border:3px solid #D12D36;border-radius:50%;background:#F4F4F4;overflow:hidden;pointer-events:none;' +
      'box-shadow:0 6px 18px rgba(33,29,30,.28)}' +
    '.nl-flug img{width:100%;height:100%;object-fit:cover;display:block}' +
    '@keyframes nl-wackel{0%,100%{transform:rotate(0)}20%{transform:rotate(-14deg) scale(1.12)}45%{transform:rotate(11deg) scale(1.12)}70%{transform:rotate(-6deg)}85%{transform:rotate(3deg)}}' +
    '.nl-wackel{animation:nl-wackel .55s ease-in-out;transform-origin:50% 60%}' +
    '@keyframes nl-hupf{0%,100%{transform:scale(1)}40%{transform:scale(1.55)}70%{transform:scale(.9)}}' +
    '.nl-hupf{animation:nl-hupf .45s ease-out}';

  function flugCssEinbauen() {
    if (document.getElementById('nl-flug-css')) return;
    var st = document.createElement('style');
    st.id = 'nl-flug-css';
    st.textContent = FLUG_CSS;
    document.head.appendChild(st);
  }

  // letzten Klick auf einen Warenkorb-Button merken (Capture, damit nichts dazwischenfunkt)
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(KNOPF_SELEKTOR);
    if (b) letzterKlick = { knopf: b, zeit: Date.now() };
  }, true);

  function sichtbar(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function produktBild(knopf) {
    var bereich = knopf && knopf.closest('.card-wrapper, .card, product-info, .product, .quick-add-modal__content');
    var bild = bereich && bereich.querySelector('.product__media-item img, .product__media img, .card__media img, img');
    if (!bild) bild = document.querySelector('.product__media-item img, .product__media img');
    return bild ? (bild.currentSrc || bild.src) : '';
  }

  function wagerlIcon() {
    return document.getElementById('cart-icon-bubble');
  }

  // Flug starten; liefert ein Promise, das nach der Landung erfüllt ist
  function fliegen() {
    return new Promise(function (fertig) {
      var knopf = letzterKlick.knopf;
      var frisch = knopf && (Date.now() - letzterKlick.zeit) < 15000;
      var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!frisch || ruhig || !document.body.animate) { fertig(); return; }
      letzterKlick = { knopf: null, zeit: 0 };

      // Header einblenden, falls er beim Runterscrollen versteckt wurde
      var kopf = document.querySelector('sticky-header');
      if (kopf && typeof kopf.reveal === 'function') { try { kopf.reveal(); } catch (err) {} }

      setTimeout(function () {
        var ziel = wagerlIcon();
        var start = sichtbar(knopf) ? knopf : document.querySelector('.product__info-container .product-form__submit');
        if (!ziel || !sichtbar(ziel) || !start || !sichtbar(start)) { fertig(); return; }

        flugCssEinbauen();
        var a = start.getBoundingClientRect();
        var z = ziel.getBoundingClientRect();
        var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2;
        var x1 = z.left + z.width / 2, y1 = z.top + z.height / 2;
        // Scheitelpunkt des Bogens: etwas über dem höheren Punkt
        var xm = x0 + (x1 - x0) * 0.45, ym = Math.min(y0, y1) - 70;

        var el = document.createElement('div');
        el.className = 'nl-flug';
        el.setAttribute('aria-hidden', 'true');
        var src = produktBild(knopf);
        if (src) el.innerHTML = '<img src="' + esc(src) + '" alt="">';
        document.body.appendChild(el);

        var anim = el.animate([
          { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(1)', opacity: 1, offset: 0 },
          { transform: 'translate(' + xm + 'px,' + ym + 'px) scale(.8)', opacity: 1, offset: 0.5 },
          { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.22)', opacity: 0.9, offset: 1 }
        ], { duration: FLUG_MS, easing: 'cubic-bezier(.45,.05,.55,.95)', fill: 'forwards' });

        var erledigt = false;
        function ende() {
          if (erledigt) return;
          erledigt = true;
          el.remove();
          var icon = wagerlIcon();
          if (icon) {
            icon.classList.remove('nl-wackel');
            void icon.offsetWidth;
            icon.classList.add('nl-wackel');
            setTimeout(function () { icon.classList.remove('nl-wackel'); }, 600);
          }
          fertig();
        }
        anim.onfinish = ende;
        setTimeout(ende, FLUG_MS + 300); // Sicherheitsnetz
      }, 30);
    });
  }

  // Flug startet, sobald der Artikel wirklich abgeschickt wird (Anfrage an /cart/add),
  // also erst nach "Zweite Kassa bitte" und nach Gelatos Prüfung – parallel zur Anfrage.
  var laufenderFlug = null;
  var flugZeit = 0;
  function flugAktuell() { return laufenderFlug && (Date.now() - flugZeit) < 15000; }
  if (window.fetch && !window.fetch.__nlFlugFetch) {
    var fetchVorher = window.fetch;
    var fetchMitFlug = function (resource) {
      try {
        var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && letzterKlick.knopf && !flugAktuell()) {
          laufenderFlug = fliegen();
          flugZeit = Date.now();
        }
      } catch (err) {}
      return fetchVorher.apply(this, arguments);
    };
    fetchMitFlug.__nlFlugFetch = true;
    fetchMitFlug.__nlPatched = window.fetch.__nlPatched;
    window.fetch = fetchMitFlug;
  }

  function zahlHuepfen() {
    setTimeout(function () {
      var zahl = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      if (zahl) { zahl.classList.add('nl-hupf'); setTimeout(function () { zahl.classList.remove('nl-hupf'); }, 500); }
    }, 30);
  }

  // Seitenansicht erst nach der Landung öffnen
  if (window.customElements) {
    customElements.whenDefined('cart-drawer').then(function () {
      var Klasse = customElements.get('cart-drawer');
      if (!Klasse || !Klasse.prototype.renderContents || Klasse.prototype.renderContents.__nlFlug) return;
      var original = Klasse.prototype.renderContents;
      var mitFlug = function () {
        var self = this;
        var args = arguments;
        var warten = flugAktuell() ? laufenderFlug : (letzterKlick.knopf ? fliegen() : null);
        laufenderFlug = null;
        if (!warten) { original.apply(self, args); return; }
        warten.then(function () { original.apply(self, args); zahlHuepfen(); });
      };
      mitFlug.__nlFlug = true;
      Klasse.prototype.renderContents = mitFlug;
    });
  }

  /* ---------- Nach jedem Neuzeichnen (Menge ändern, Artikel hinzufügen) ---------- */
  var zeitgeber = null;
  function aktualisieren() {
    clearTimeout(zeitgeber);
    zeitgeber = setTimeout(function () {
      allePfeile();
      var offen = Array.prototype.some.call(alleBereiche(), function (b) {
        var l = b.querySelector('.nl-code__liste');
        return l && l.dataset.nlGefuellt !== '1';
      });
      if (offen) warenkorb().then(chipsFuellen).catch(function () {});
    }, 60);
  }

  function start() {
    aktualisieren();
    var beobachten = [document.getElementById('CartDrawer'), document.getElementById('main-cart-items')];
    beobachten.forEach(function (el) {
      if (el) new MutationObserver(aktualisieren).observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
